module.exports = "<div [id]=\"this.chartSpecification.divId\" class=\"chartDiv\"></div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/pie/donute-chart/donut-chart.component.html
// module id = ../../../../../app/shared/components/charts/pie/donute-chart/donut-chart.component.html
// module chunks = main